import { createSafeContext } from '@sgme/react';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export const [QuoteWorkspaceProvider, useQuoteWorkspaceContext] =
  createSafeContext<QuoteWorkspaceType>('quoteWorkspace');
